"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cordovado": {
    "6f72a7a5": [{
      "hkey": "9bc20702",
      "slug": "cordovado",
      "name": "Cordovado",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "9bc20702",
      "slug": "cordovado",
      "name": "Cordovado",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a535fb45": [{
      "hkey": "9bc20702",
      "slug": "cordovado",
      "name": "Cordovado",
      "primary": true,
      "skipSearch": false
    }],
    "saccudello": [{
      "hkey": "9bc20702",
      "slug": "cordovado",
      "name": "Cordovado",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1de26c1a": [{
      "hkey": "9bc20702",
      "slug": "cordovado",
      "name": "Cordovado",
      "primary": true,
      "skipSearch": false
    }],
    "suzzolins": [{
      "hkey": "9bc20702",
      "slug": "cordovado",
      "name": "Cordovado",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;